import React, { useState, useCallback, useEffect } from 'react'
import Container from '@/component/Primitive/Container'
import Stack from '@/component/Primitive/Stack'
import Type from '@/component/Primitive/Type'
import styles from './Description.module.scss'
import { string } from 'prop-types'
import cx from 'classnames'

export const Description = ({ description, descriptionDetails }) => {
  const isLongDescription = (d) => {
    if (!d) return false
    return d.length > 200
  }
  const [isClickable, setIsClickable] = useState(isLongDescription(description))
  const [displayedDescription, setDisplayedDescription] = useState(description)
  const [showFullDescription, setShowFullDescription] = useState(false)

  const determineDescription = useCallback(() => {
    if (!description) return ''
    return description.length > 200
      ? description.slice(0, 200) + '...'
      : description
  }, [description])

  useEffect(() => {
    setDisplayedDescription(determineDescription())
  }, [description, determineDescription])

  const showFullDescriptionHandler = () => {
    if (!description) return
    if (description.length <= 200) return
    if (!showFullDescription) {
      setDisplayedDescription(description)
    } else {
      setDisplayedDescription(determineDescription())
    }
    setIsClickable(isLongDescription(description))
    setShowFullDescription(!showFullDescription)
  }

  return (
    <button
      onClick={() => showFullDescriptionHandler()}
      className={cx(
        styles.DescriptionContainerWrapper,
        isClickable && styles.clickable
      )}
    >
      <Container center size="wide">
        <Type size={['body4', 'body3']} weight="bold">
          {descriptionDetails}
        </Type>
        <Stack gap="small" className={styles.DescriptionWrapper}>
          <Type size={['body4', 'body3']}>
            <p dangerouslySetInnerHTML={{ __html: displayedDescription }} />
          </Type>
          {description && description.length > 200 && (
            <Type weight="bold" size={['body4', 'body4']}>
              Show {!showFullDescription ? 'more' : 'less'}
            </Type>
          )}
        </Stack>
      </Container>
    </button>
  )
}

Description.propTypes = {
  description: string,
  descriptionDetails: string
}
